module.exports = __webpack_public_path__ + "img/plan-3-3.d27f0b59.png";